var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:_vm.thin?'thin':'',attrs:{"id":_vm.btnId,"variant":_vm.variant,"disabled":_vm.loading || _vm.disable,"title":_vm.name},on:{"click":_vm.whenClick}},[(_vm.loading)?_c('b-spinner',{attrs:{"small":"","type":_vm.loadingType}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }